(() => { 
  const { createApp } = Vue;
  const SELECTORS = {
    app: '#custom-swing-set'
  };
  const MOBILE_SIZE = '479px';

  let $section = document.querySelector(SELECTORS.app);
  if (!$section) return;

  let formatMoney = (value) => {
    return theme.Currency.formatMoney(value);
  }

  let getTextContent = (html) => {
    // Create a new div element
    var tempDivElement = document.createElement("div");
    // Set the HTML content with the given value
    tempDivElement.innerHTML = html;
    // Retrieve the text property of the element 
    return tempDivElement.textContent || tempDivElement.innerText || "";    
  }  

  let isMobile = () => {
    return window.matchMedia(`(max-width: ${ MOBILE_SIZE })`).matches;
  }

  let addItemsToCart = (items, cart_type) => {
    return new Promise((resolve, reject) => { 
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items })
      })
        .then(res => res.json())
        .then((res) => {
          resolve(res);
          // events after add to cart
          if (cart_type == 'page') {
            window.location.href = '/cart';
          }
          else {
            document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
          }
        })
        .catch(reject);
    });
  }

  createApp({
    delimiters: ['${', '}'],
    data() { 
      return {
        APP_DATA,
        showLifeStyleImages: false,
        isMobile: isMobile()
      };
    },
    computed: {
      product() {
        return this.APP_DATA.product;
      },
      main_variant() { 
        return this.product.current_variant;
      },
      total_price() { 
        let total_price = 0;

        let addons_price = this.selected_addons.reduce((sum, addon) => (sum + addon.price), 0);
        total_price = this.main_variant.price + addons_price;

        return {
          price: total_price,
          price_fm: formatMoney(total_price)
        };
      },
      addon_images() { 
        return this.APP_DATA.addon_images;
      },
      lifestyle_images() {
        return this.product.media.filter(m => m.alt == 'lifestyle');
      },
      stations() {
        let vm = this;
        let stations = Array.isArray(vm.APP_DATA.stations) ? vm.APP_DATA.stations : [];
        let addon_images = vm.addon_images;

        stations = stations.filter((station) => {
          return Array.isArray(station) && station.some((item) => item && Array.isArray(item.variants));
        });

        stations = stations.map((station, stationIndex) => {
          var variants = [];
          station.forEach((item) => { 
            item.variants.forEach((v) => {
              v.product_id = item.id;

              if (!v.featured_image) {
                v.featured_image = item.media[0];
              }
              v.selected = false;
              v.addon_images = addon_images.filter(img => img.variant_id == v.id);

              // tooltip + cart prop
              let price = getTextContent(formatMoney(v.price));
              price = price.replace(' AUD', '');
              v.tooltip = [v.name, ' +', price].join('');

              v.HIDE = vm.HIDE_ADDON(v);
              
              variants.push(v);
            });
          });

          //Preselect first item for each station (except accessory)
          let isAccessoryStation = stationIndex == stations.length - 1;
          if (!isAccessoryStation) {
            let firstAddonVariant = variants[0];
            firstAddonVariant.selected = true;
            firstAddonVariant.station = (stationIndex + 1);
          }

          return {
            index: (stationIndex + 1),
            items: station,
            variants: variants
          };
        });

        return stations;
      },
      station_titles() { 
        let station_titles = this.stations.map((station, stationIndex) => { 
          let isLastStation = stationIndex == (this.stations.length - 1);
          return (!isLastStation) ? `SWING STATION ${(stationIndex + 1)}` : 'ADD-ONS (EXTRAS)'
        });

        return station_titles;
      },
      selected_addons() {
        let selected_addons = [];
        this.stations.forEach((station) => { 
          let selected_addon_variants = station.variants.filter(v => v.selected);
          selected_addon_variants.forEach((variant) => {
            selected_addons.push(variant);
          });
        });

        return selected_addons;
      },

      incompleteStations() {
        let vm = this;
        let incompleteStations = vm.stations.filter((station, stationIndex) => {
          let isAccessoryStation = stationIndex == vm.stations.length - 1;
          return !isAccessoryStation && station.variants.filter(v => v.selected).length == 0;
        });
        return incompleteStations;
      },

      selected_addons_props() {
        let vm = this;
        let selected_addons_props = [];
        vm.selected_addons.forEach((v) => {
          let station_title = vm.station_titles[v.station - 1];
          selected_addons_props.push(`${station_title} - ${v.tooltip}`);
        });

        return selected_addons_props.join(',');
      }
    },
    watch: {
      main_variant() {
        let $frameColor_label = document.querySelector('.variant__label-info span');
        if ($frameColor_label) {
          $frameColor_label.textContent = this.main_variant.title;
        }
      }
    },
    mounted() {
      vm = this;
      vm.initVariantSelection();

      const mql = window.matchMedia(`(max-width: ${ MOBILE_SIZE })`);
      mql.onchange = () => {
        let is_mobile = isMobile();
        vm.isMobile = is_mobile;
        vm.showLifeStyleImages = is_mobile ? false : true;
      };
    },
    methods: {
      getRandomId() {
        return '_' + Math.random().toString(36).substr(2, 9);
      },
      
      clearAddons(e) {
        let vm = this;
        
        e.preventDefault();
        vm.stations.forEach((station) => { 
          station.variants.forEach((v) => { 
            v.selected = false;
            v.station = null;
          });
        });
      },

      selectAddon(e, stationIndex, addon_variant) {
        //console.log({e, stationIndex, addon_variant})
        let vm = this;
        let isSelected = addon_variant.selected;
        let isAccessories = stationIndex == (vm.stations.length - 1);

        // clear previous selections
        if (!isAccessories) {
          vm.stations[stationIndex].variants.forEach((v) => {
            v.selected = false;
            v.station = null;
          });
        }

        // toggle selection
        addon_variant.selected = !isSelected;
        addon_variant.station = (stationIndex + 1);
      },

      getSelectedAddonImageSrc(addon_variant) {
        let vm = this;
        let isLastStation = addon_variant.station == vm.stations.length;
        let sku_prefix = '';

        if (vm.product.handle.indexOf('cheeky') !== -1) {
          sku_prefix = 'cheeky-';
        }
        if (vm.product.handle == 'the-cheeky-little-monkey-1-station-swing-set') {
          sku_prefix = 'cheeky-1--';
        }

        let alt_to_match = !isLastStation ? `${ addon_variant.sku }-station-${ addon_variant.station }` : `${ addon_variant.sku }-extras`;
        alt_to_match = `${ sku_prefix }${ alt_to_match }`;
        
        let addon_image = vm.addon_images.find(img => img.alt.indexOf(alt_to_match) !== -1);
        if (!addon_image) {
          console.error(`NO IMAGE FOUND for "${ alt_to_match }", product: ${ addon_variant.product_id }, "${ addon_variant.name }"`);
        }
        
        return addon_image ? addon_image.src : '';
      },

      initVariantSelection() { 
        let vm = this;
        document.querySelectorAll('.variant-input[data-index="option1"] input[type="radio"]')
          .forEach(($radio) => {
            $radio.addEventListener('change', (e) => { 
              let color = $radio.dataset.colorName;
              vm.APP_DATA.product.current_variant = vm.product.variants.find(v => v.option1 == color);
            });
          });
      },

      addItemsToCart(e) {
        let vm = this;
        let $btn = e.currentTarget;
        let cart_type = $btn.dataset.cart_type;
        let bundle_id = vm.getRandomId();
        e.preventDefault();

        let frame_item = [{
          id: vm.main_variant.id,
          quantity: 1,
          properties: {
            '_addons': vm.selected_addons_props,
            '_total_price': vm.total_price.price,
            '_bundle_id': bundle_id
          }
        }];

        let addon_items = vm.selected_addons.map((addon_variant) => {
          return {
            id: addon_variant.id,
            quantity: 1,
            properties: {
              '_is_addon': true,
              '_bundle_id': bundle_id
            }
          };
        });

        let items_to_add = [].concat(frame_item, addon_items);
        
        addItemsToCart(items_to_add, cart_type)
          .then(console.log)
          .catch(console.error);
      },

      HIDE_ADDON(variant) {
        if (!variant || !variant.sku) return false;

        let HIDE_ADDONS_SKUS = [];
        switch(this.product.handle) {
          case 'station-3-model':
          case 'the-cheeky-little-monkey-2-station-swing-set':
            HIDE_ADDONS_SKUS = ['NETHOOPS'];
            break;
          case 'station-2-model':
          case 'station-1-model':
          case 'the-cheeky-little-monkey-1-station-swing-set':
              HIDE_ADDONS_SKUS = ['NETHOOPS', 'BIRD3000'];
            break;
          }

        return HIDE_ADDONS_SKUS.indexOf(variant.sku) !== -1;
      },

      toggleLifestyleImages() {
        this.showLifeStyleImages = !this.showLifeStyleImages;
      }
    }
  }).mount(SELECTORS.app);
})();